'use strict';

const progressUtils = require('./progress');

exports.init = function init() {
    // subscribe email box
    var $subscribeEmail = $('.subscribe-email');
    if ($subscribeEmail.length > 0) {
        $subscribeEmail.focus(function () {
            var val = $(this.val());
            if (val.length > 0 && val !== Resources.SUBSCRIBE_EMAIL_DEFAULT) {
                return; // do not animate when contains non-default value
            }

            $(this).animate({ color: '#999999' }, 500, 'linear', function () {
                $(this).val('').css('color', '#333333');
            });
        }).blur(function () {
            var val = $.trim($(this.val()));
            if (val.length > 0) {
                return; // do not animate when contains value
            }
            $(this).val(Resources.SUBSCRIBE_EMAIL_DEFAULT)
                .css('color', '#999999')
                .animate({ color: '#333333' }, 500, 'linear');
        });
    }

    // footer email signup - placeholder swap
    var $formEmailSignup = $('.form-email-sign-up');
    const emailSpinnerLoader = new progressUtils.SpinnerLoader($formEmailSignup);
    var $uts = $('.ust_us');

    $uts.find('.email-input').on('focus', function () {
        $uts.find('.email-formfield').addClass('background');
    });

    $formEmailSignup.find('.email-input').on('focus', function () {
        $(this).removeClass('hidden-placeholder');
        $formEmailSignup.find('.email-label').addClass('ms-hide');
    });

    // bubablade list joining  - footer subscription form handle
    var $mCSubscriptionForm = $('#MCSubscriptionForm');

    if ($mCSubscriptionForm.length > 0) {
        $mCSubscriptionForm.on('submit', function (e) {
            e.preventDefault();
            emailSpinnerLoader.show();

            if ($('#subscription-checkbox').is(':checked') && $('.form-email-sign-up').valid()) {
                $.ajax({
                    type: 'POST',
                    url: Urls.mcSubscribeSubmit,
                    data: $mCSubscriptionForm.serializeArray()
                }).done(function (response) {
                    var success = response && response.success;

                    emailSpinnerLoader.hide();

                    // Add Info to GTM
                    var dataGtm = $('#email_signup').attr('data-gtm');
                    var parsedJson;
                    try {
                        parsedJson = JSON.parse(dataGtm);
                    } catch (error) {
                        parsedJson = JSON.parse(dataGtm.replace(/'/gi, '"').replace(/\\"/, '\''));
                    }
                    parsedJson.event = 'clickNewsletter';
                    delete parsedJson.eventTypes;

                    if (success) {
                        $('#mcSubscribeSuccess').show();
                        $('#mcSubscribe').hide();
                        parsedJson.action = 'success';
                    } else if (response.preferencesError) {
                        $('#mcSubscribePreferencesError').show();
                        $('#mcSubscribe').hide();
                        parsedJson.action = 'error';
                    } else {
                        $('#mcSubscribeError').show();
                        $('#mcSubscribe').hide();
                        parsedJson.action = 'error';
                    }

                    $('.tryAgainLink').on('click', function (e) {
                        e.preventDefault();
                        $(this).parent().parent().hide();
                        $('#mcSubscribe').show();
                        $('#email_signup').focus();
                    });

                    if (typeof dataLayer == 'object') {
                        dataLayer.push(parsedJson);
                    }
                });
            } else {
                emailSpinnerLoader.hide();
            }
        });
    }

    // set email submit button to disabled or enabled
    var $subscriptionForm = $('.form-email-sign-up'),
        $emailSubmit = $('.email-submit'),
        $emailInput = $('.email-input'),
        $subscriptionCheckbox = $('#subscription-checkbox');

    const checkValidSubscription = () => {
        const formValidator = $subscriptionForm.validate();
        const isFormValid = formValidator.checkForm();

        // Reset immediate form field checking mode
        formValidator.submitted = {};

        return $subscriptionCheckbox.is(':checked') && isFormValid && $emailInput.val();
    };

    const switchSubscriptionAbility = () => {
        $emailSubmit.prop('disabled', !checkValidSubscription());
    };

    $subscriptionCheckbox.on('change', switchSubscriptionAbility);
    $emailInput.on('input change', switchSubscriptionAbility);

    if ($emailInput.val()) {
        $formEmailSignup.find('.email-label').addClass('ms-hide');
    }

    if (checkValidSubscription()) {
        $emailSubmit.prop('disabled', false);
    }
};
